import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Store } from 'libx';
import { createIamAPI } from './API';
import env from '../misc/env';
import Translation from './Translation';
var TranslationStore = /*#__PURE__*/function (_Store) {
  function TranslationStore() {
    var _this;
    _classCallCheck(this, TranslationStore);
    _this = _callSuper(this, TranslationStore, arguments);
    _this.translations = _this.collection({
      model: Translation
    });
    _this.api = createIamAPI({
      baseURL: env.IAM_API,
      getToken: _this.rootStore.authStore.getToken
    });
    return _this;
  }
  _inherits(TranslationStore, _Store);
  return _createClass(TranslationStore, [{
    key: "forWorkspace",
    value: function forWorkspace(workspaceId) {
      return this.translations.filter(function (x) {
        return x.workspaceId === workspaceId;
      });
    }
  }, {
    key: "dictonaryForWorkspace",
    value: function dictonaryForWorkspace(workspaceId) {
      var translations = this.forWorkspace(workspaceId);
      var result = {};
      var _iterator = _createForOfIteratorHelper(translations),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var translation = _step.value;
          if (result[translation.key]) {
            result[translation.key][translation.locale] = translation.value;
          } else {
            result[translation.key] = _defineProperty({}, translation.locale, translation.value);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return result;
    }
  }, {
    key: "fetchAll",
    value: function () {
      var _fetchAll = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(workspaceId) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this.api.translations.getAll(workspaceId).then(this.translations.set));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function fetchAll(_x) {
        return _fetchAll.apply(this, arguments);
      }
      return fetchAll;
    }()
  }, {
    key: "upsert",
    value: function () {
      var _upsert = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(data) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", this.api.translations.upsert(data).then(this.translations.set));
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function upsert(_x2) {
        return _upsert.apply(this, arguments);
      }
      return upsert;
    }()
  }, {
    key: "remove",
    value: function () {
      var _remove = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(id) {
        var _this2 = this;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", this.api.translations.remove(id).then(function () {
                return _this2.translations.remove(id);
              }));
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function remove(_x3) {
        return _remove.apply(this, arguments);
      }
      return remove;
    }()
  }]);
}(Store);
export { TranslationStore as default };
//# sourceMappingURL=TranslationStore.js.map
